import { render } from "./CustomDialogGuangDong.vue?vue&type=template&id=27a720de&scoped=true&ts=true"
import script from "./CustomDialogGuangDong.vue?vue&type=script&lang=ts"
export * from "./CustomDialogGuangDong.vue?vue&type=script&lang=ts"

import "./CustomDialogGuangDong.vue?vue&type=style&index=0&id=27a720de&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a720de"]])

export default __exports__